<template>
    <div id="campaigns" :class="!hasCampaigns && 'bg-dark'" >
        <loading v-if="loading && displayMode === 'CARD'"></loading>

        <div id="up-scroll" @click="scrollTop" v-if="displayMode === 'CARD'">
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-icon class="white--text">keyboard_arrow_up</v-icon>
                            </span>
                </template>
                <span>Retour en haut</span>
            </v-tooltip>
        </div>
        <div class="app-container position-relative mb-5" v-show="!$global.loading">
            <div v-if="!hasCampaigns">
                <div class="d-flex flex-column justify-content-center align-items-center text-center gap-30"
                     id="init-container">
                    <h4 class="text-white" v-if="isAccountConfigured">Vous n'avez pas encore programmé de campagne...
                    </h4>
                    <h4 class="text-white" v-else>Vous pourrez programmer vos campagnes une fois que votre compte sera
                        finalisé.</h4>

                    <div v-if="isAccountConfigured">
                        <div class="d-flex justify-content-center align-items-center gap-30">
                            <div class="init-action" :class="!isCmajAvailable && 'disable'"
                                 @click="prepareCmajCampaign">
                                <div class="d-flex flex-column justify-content-center align-items-center gap-20 p-5">
                                    <v-icon class="init-action-icon" large>autorenew</v-icon>
                                    <h5>Programmer une campagne de mise à jour</h5>
                                </div>
                            </div>
                            <div class="init-action" :class="!isCadhAvailable && 'disable'"
                                 @click="prepareCadhCampaign">
                                <div class="d-flex flex-column justify-content-center align-items-center gap-20 p-5">
                                    <v-icon class="init-action-icon" large>mdi-clipboard-check-outline</v-icon>
                                    <h5>Programmer une campagne d'adhésion</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="init-action" @click="prepareConfigAccount">
                            <div class="d-flex flex-column justify-content-center align-items-center gap-20 p-5">
                                <v-icon class="init-action-icon" large>settings</v-icon>
                                <h5>Finaliser ma configuration</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else>
                <div class="d-flex justify-content-between mt-5">

                    <div class="d-flex">

                        <div class="page-title">
                            <span class="breadcrumb-link">
                                <v-icon class="breadcrumb-link-icon">dashboard</v-icon> Mes campagnes <span
                              v-if="!$global.loading && count">({{ count }})</span>
                            </span>
                        </div>

                        <div class="d-flex">
                            <div class="display-mode d-flex ml-5 mt-auto mb-auto">
                                <div class="mt-auto mb-auto cliquable-state" :class="{ 'active': isArchived }"
                                     @click="setArchived(true)">
                                    Archivées
                                </div>
                                <div class="mt-auto mb-auto cliquable-state" :class="{ 'active': !isArchived }"
                                     @click="setArchived(false)">
                                    En cours
                                </div>
                            </div>

                            <div class="ml-5 d-flex display-mode mt-auto mb-auto">
                                <div class="cliquable-state" :class="{ 'active': displayMode === 'CARD' }"
                                     @click="setMode('CARD')">
                                    <v-icon>grid_view</v-icon>
                                </div>
                                <div class="cliquable-state" :class="{ 'active': displayMode === 'LIST' }"
                                     @click="setMode('LIST')">
                                    <v-icon>view_list</v-icon>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="d-flex actions-list">
                        <v-menu bottom transition="slide-y-transition" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="default-button" v-on="on" :disabled="!selectedCampaigns.length">
                                    Sur la sélection
                                    <v-icon>arrow_drop_down</v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item @click="archiveSelectedCampaigns" :disabled="archived">
                                    <v-list-item-title>
                                        Archiver les campagnes sélectionnées
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="deleteSelectedCampaigns"
                                :disabled="deletableSelectedCampaigns.length === 0">
                                    <v-list-item-title>
                                        Supprimer les campagnes sélectionnées
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="openUpdateSentAtModale">
                                    <v-list-item-title>
                                        Modifier les dates d'envoi des campagnes sélectionnées
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                        <v-menu bottom transition="slide-y-transition" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="default-button" v-on="on">
                                    Actions
                                    <v-icon>arrow_drop_down</v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item :disabled="!isAccountConfigured || !isCmajAvailable"
                                             @click="prepareCmajCampaign">
                                    <v-list-item-title>
                                        Programmer une campagne de mise à jour
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item :disabled="!isAccountConfigured || !isCadhAvailable"
                                             @click="prepareCadhCampaign">
                                    <v-list-item-title>
                                        Programmer une campagne d'adhésion
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item :disabled="!isAccountConfigured || !isCmajAvailable"
                                             @click="aspectChoiceModale = true"
                                             v-if="account.tis_type.code === 'APIDAE' && account.configurations.aspectCampaign">
                                    <v-list-item-title>
                                        Programmer une campagne de mise à jour sur les aspects
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </div>

                <v-card class="mt-5 filter-card">
                    <v-card-title>
                        <div class="d-flex w-100">
                            <div style="width: calc(200% / 3)" class="mr-4">
                                <v-text-field append-icon="mdi-magnify" label="Rechercher par nom" clearable
                                              v-model="search"
                                              style="padding-top: 0 !important;" outlined
                                              hide-details>
                                </v-text-field>
                            </div>

                            <div style="width: calc(200% / 3)" class="mr-4">
                                <v-select :items="campaignTypes" style="padding-top: 0 !important;" hide-details
                                          multiple small-chips outlined item-text="label" item-value="name"
                                          v-model="campaignType" chips label="Type de campagne">
                                    <template #selection="{ item, index }">
                                        <v-chip small dark @click:close="removeCampaignType(index)"
                                                :class="getColor(item.name)">
                                            {{ item.label }}
                                        </v-chip>
                                    </template>
                                </v-select>
                            </div>

                            <div style="width: calc(200% / 3)">
                                <v-checkbox label="Seulement mes campagnes" style="padding-top: 0 !important;" @change="setOwnCampaign"
                                            v-model="ownCampaign" :true-value="true" :false-value="false"
                                            class="mt-auto mb-auto ml-2 ml-5" hide-details>
                                </v-checkbox>
                            </div>
                        </div>
                    </v-card-title>
                </v-card>

                <div v-if="!$global.loading">
                    <div v-if="displayMode === 'CARD'">
                        <v-card class="info-cards p-4" v-if="filteredCampaigns.length > 0">
                            <v-card v-for="campaign in filteredCampaigns" :key="campaign.id">
                                <v-app-bar dark :class="getCampaignNavColor(campaign)">
                                    <v-toolbar-title class="w-100 h-100"
                                                     :class="{'hoverable': campaign.state.code !== 'WAIT_FIRST_SENT' && campaign.state.code !== 'DRAFT'}">
                                        <div class="d-flex justify-content-between h-100 pr-3">
                                            <v-checkbox
                                              class="mt-auto mb-auto pl-3" style="padding-top: 0!important;"
                                              @change="selectCampaign(campaign)" :input-value="selectedCampaigns.includes(campaign)"
                                              hide-details>
                                            </v-checkbox>
                                            <div class="pl-3 d-flex"
                                                 style="width: calc(100% - 60px);max-width: calc(100% - 60px);"
                                                 :style="{ 'cursor' : campaign.state.code !== 'WAIT_FIRST_SENT' && campaign.state.code !== 'DRAFT' ? 'pointer' : 'default'}"
                                                 @click="redirectCampaignProviders(campaign)">
                                                <div class="mt-auto mb-auto cmaj-title ">{{ campaign.name }}</div>
                                            </div>
                                            <div v-if="campaign.state.code !== 'DRAFT'" class="mt-auto mb-auto">
                                                <v-menu bottom left transition="slide-x-reverse-transition">
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn small icon v-on="on">
                                                            <v-icon>mdi-dots-vertical</v-icon>
                                                        </v-btn>
                                                    </template>

                                                    <v-list>
                                                        <v-list-item @click="prepareRenameDialog(campaign)">
                                                            <v-list-item-title>
                                                                Renommer
                                                            </v-list-item-title>
                                                        </v-list-item>

                                                        <v-list-item v-if="campaign.last_batch.state.code !== 'WAITING'"
                                                                     @click="redirectCampaignConfig(campaign)">
                                                            <v-list-item-title>
                                                                Voir la dernière configuration de la campagne
                                                            </v-list-item-title>
                                                        </v-list-item>

                                                        <v-list-item @click="duplicate(campaign)"
                                                                     :disabled="!isAccountConfigured || !isCmajAvailable"
                                                                     v-if="campaign.type !== 'CADH'">
                                                            <v-list-item-title>
                                                                Dupliquer la campagne
                                                            </v-list-item-title>
                                                        </v-list-item>

                                                        <v-list-item @click="archive(campaign)"
                                                                     :disabled="isSending(campaign)" v-if="!archived">
                                                            <v-list-item-title>
                                                                Archiver
                                                            </v-list-item-title>
                                                        </v-list-item>

                                                        <v-list-item @click="deleteCampaign(campaign)"
                                                                     v-if="deletableStates.includes(campaign.state.code)"
                                                        >
                                                            <v-list-item-title class="text-error">
                                                                Supprimer
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </div>
                                            <div v-else class="mt-auto mb-auto">
                                                <v-menu bottom left transition="slide-x-reverse-transition">
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn small icon v-on="on">
                                                            <v-icon>mdi-dots-vertical</v-icon>
                                                        </v-btn>
                                                    </template>

                                                    <v-list>
                                                        <v-list-item @click="redirectUpdateCampaign(campaign)">
                                                            <v-list-item-title>
                                                                Modifier
                                                            </v-list-item-title>
                                                        </v-list-item>

                                                        <v-list-item @click="prepareRenameDialog(campaign)">
                                                            <v-list-item-title>
                                                                Renommer
                                                            </v-list-item-title>
                                                        </v-list-item>

                                                        <v-list-item @click="deleteCampaign(campaign)"
                                                                     v-if="deletableStates.includes(campaign.state.code)">
                                                            <v-list-item-title style="color: red">
                                                                Supprimer
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </div>
                                        </div>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-app-bar>

                                <v-card-text
                                  v-if="campaign.state.code !== 'DRAFT' && campaign.state.code !== 'IMPORTING'">
                                    <div class="d-flex justify-content-between">
                                        <div class="mt-auto mb-auto">
                                            <b v-if="campaign.last_batch.state.code !== 'FINISHED'">
                                                {{ campaign.last_batch.state.label }}</b>
                                            <b v-else>{{ getFinishedState(campaign) }}</b>
                                            <span v-if="campaign.last_batch.state.code === 'WAITING'"> le
                                                <b>{{ formatDate(campaign.last_batch.sent_at) }}</b>
                                            </span>
                                        </div>

                                        <div class="d-flex align-items-center">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs" v-on="on" icon color="primary"
                                                           v-if="campaign.last_batch.state.code === 'WAITING'"
                                                           @click="updateFirstSentOrRevival(campaign)">
                                                        <v-icon>edit</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Modifier</span>
                                            </v-tooltip>

                                            <div
                                              v-if="campaign.last_batch.state.code === 'FINISHED' && campaign.answer_rate < 1">
                                                <v-btn small outlined class="custom-button-primary"
                                                       @click="redirectCreateRevival(campaign)">
                                                    Relancer
                                                </v-btn>
                                            </div>

                                            <div v-if="campaign.last_batch.state.code === 'WAITING' && campaign.batches.length > 1">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" v-on="on" icon color="error"
                                                               @click="deleteRevival(campaign)">
                                                            <v-icon>mdi-calendar-remove</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Annuler</span>
                                                </v-tooltip>
                                            </div>

<!--                                            <div v-else-if="campaign.last_batch.state.code === 'WAITING' && campaign.batches.length === 1">-->
<!--                                                <v-tooltip bottom>-->
<!--                                                    <template v-slot:activator="{ on, attrs }">-->
<!--                                                        <v-btn v-bind="attrs" v-on="on" icon color="error"-->
<!--                                                               @click="deleteCampaign(campaign)">-->
<!--                                                            <v-icon>mdi-calendar-remove</v-icon>-->
<!--                                                        </v-btn>-->
<!--                                                    </template>-->
<!--                                                    <span>Annuler</span>-->
<!--                                                </v-tooltip>-->
<!--                                            </div>-->

                                        </div>
                                    </div>

                                    <div v-if="campaign.state.code !== 'WAIT_FIRST_SENT'">
                                        <hr>

                                        <div class="mt-3">
                                            <v-icon>assignment</v-icon>
                                            Prestataires : <b>{{
                                                campaign.contacted_providers
                                            }}</b>
                                        </div>

                                        <div class="mt-3">
                                            <v-icon>show_chart</v-icon>
                                            Taux de réponse : <b>{{
                                                getResponseRate(campaign)
                                            }}%</b>
                                        </div>

                                        <div class="mt-3">
                                            <v-icon>show_chart</v-icon>
                                            Taux d'ouverture :
                                            <span
                                              v-if="campaign.opened_form_rate !== undefined && campaign.opened_form_rate !== null">
                                            <b>{{ getOpenedFormRate(campaign) }}</b>
                                        </span>
                                            <span v-else>
                                            <b>Non disponible</b>
                                        </span>
                                        </div>

                                        <div class="mt-3">
                                            <v-icon>show_chart</v-icon>
                                            Taux d'avancement : <b>{{
                                                getCompleteRate(campaign)
                                            }}%</b>
                                        </div>

                                        <div class="mt-3 d-flex justify-content-between">
                                            <div class="mt-auto mb-auto">
                                                <v-icon>pending_actions</v-icon>
                                                Réponses à traiter :
                                                <b>{{ campaign.responses_to_send }}</b>
                                            </div>

                                            <div v-if="campaign.responses_to_send > 0">
                                                <v-btn small outlined class="custom-button-primary"
                                                       @click="redirectAnswer(campaign)">
                                                    Consulter
                                                </v-btn>
                                            </div>
                                        </div>

                                        <div class="mt-3 d-flex justify-content-between"
                                             v-if="campaign.apidae_selection !== null && campaign.apidae_selection !== undefined">
                                            <div class="mt-auto mb-auto">
                                                <v-icon>app_registration</v-icon>
                                                Sélection :
                                                <a target="_blank"
                                                   :href="'https://base.apidae-tourisme.com/diffuser/selection/' + campaign.apidae_selection.external_id + '?9&spid=8#tab-marquages'">
                                                    <b>{{ campaign.apidae_selection.name }}</b>
                                                </a>
                                            </div>
                                        </div>

                                        <div class="mt-3">
                                            <hr v-if="campaign.batches[0].state.code === 'FINISHED'">

                                            <div v-for="(batch, index) in campaign.batches">
                                                <v-btn class="text-button" text small
                                                       @click="prepareBatchMailDialog(batch)"
                                                       v-if="batch.state.code === 'FINISHED'">
                                                    <span v-if="index === 0"><b>1er envoi effectué</b>
                                                        le {{ formatDate(batch.sent_at) }}</span>
                                                    <span v-else><b>Relance effectuée</b>
                                                        le {{ formatDate(batch.sent_at) }}</span>
                                                </v-btn>
                                            </div>
                                        </div>
                                    </div>
                                </v-card-text>

                                <v-card-text v-else>
                                    <div class="d-flex justify-content-between">
                                        <div class="mt-auto mb-auto">
                                            <b v-if="campaign.state.code === 'DRAFT'">Brouillon</b>
                                            <b v-else-if="campaign.state.code === 'IMPORTING'">Sélection en cours
                                                d'import</b>
                                        </div>
                                    </div>

                                    <hr>

                                    <div><b>Créée le</b> {{ formatDate(campaign.created_at) }}</div>
                                </v-card-text>
                            </v-card>
                        </v-card>
                        <v-card v-else class="p-3 text-center">
                            <small v-if="isArchived">Aucune campagne archivée</small>
                            <small v-else>Aucune campagne en cours</small>
                        </v-card>
                    </div>

                    <div v-else>
                        <v-card class="info-table">
                            <div v-if="filteredCampaigns.length > 0">
                                <v-data-table :headers="headers"
                                              :items="filteredCampaigns"
                                              disable-sort
                                              :items-per-page="options.itemsPerPage"
                                              :server-items-length="count"
                                              :options.sync="options"
                                              :loading="loading"
                                              sort-by="last_batch.sent_at" sort-desc no-data-text="Aucune campagne"
                                              class="elevation-1" :footer-props="{
                                        itemsPerPageAllText: 'Tous',
                                        itemsPerPageText: 'Campagnes par page',
                                        itemsPerPageOptions: [10, 20, 50, 100]
                                    }">
                                    <template v-slot:item.name="{ item }">
                                        <div class="d-flex">
                                            <v-checkbox
                                              class="mt-auto mb-auto" style="padding-top: 0!important;"
                                              :class="{'cadh-checkbox': item.type !== 'CMAJ'}"
                                              @change="selectCampaign(item)"
                                              :input-value="selectedCampaigns.includes(item)"
                                              hide-details>
                                            </v-checkbox>
                                            <div class="circle-CMAJ mt-auto mb-auto" v-if="item.type === 'CMAJ'
                                            && item.aspect === null"></div>
                                            <div v-else-if="item.type === 'CMAJ' && item.aspect === 'business'"
                                                 class="mt-auto mb-auto">
                                                💼
                                            </div>
                                            <div v-else-if="item.type === 'CMAJ' && item.aspect === 'winter'"
                                                 class="mt-auto mb-auto">
                                                ❄️
                                            </div>
                                            <div v-else-if="item.type === 'CMAJ' && item.aspect === 'summer'"
                                                 class="mt-auto mb-auto">
                                                🔆
                                            </div>
                                            <div class="circle-CADH mt-auto mb-auto" v-else></div>
                                            <a class="ml-3" @click="redirectCampaignProviders(item)">{{ item.name }}</a>
                                        </div>
                                    </template>
                                    <template v-slot:item.state.label="{ item }">
                                        <div v-if="item.state.code === 'DRAFT'">
                                            {{ item.state.label }}
                                        </div>
                                        <div v-else-if="item.last_batch.state.code !== 'FINISHED'">
                                            {{ item.last_batch.state.label }}
                                        </div>
                                        <div v-else>{{ getFinishedState(item) }}</div>
                                    </template>
                                    <template v-slot:item.responses_to_send="{ item }">
                                        <a @click="redirectAnswer(item)" v-if="item.responses_to_send > 0">
                                            {{ item.responses_to_send }}
                                        </a>
                                        <span v-else>{{ item.responses_to_send }}</span>
                                    </template>
                                    <template v-slot:item.answer_rate="{ item }">
                                        {{ getResponseRate(item) }}%
                                    </template>
                                    <template v-slot:item.opened_form_rate="{ item }">
                                        {{ getOpenedFormRate(item) }}
                                    </template>
                                    <template v-slot:item.complete_rate="{ item }">
                                        {{ getCompleteRate(item) }}%
                                    </template>
                                    <template v-slot:item.batches.0.sent_at="{ item }">
                                        <v-btn class="text-button" text small
                                               @click="prepareBatchMailDialog(item.batches[0])">
                                            {{ formatDate(item.batches[0].sent_at) }}
                                        </v-btn>
                                    </template>
                                    <template v-slot:item.last_batch.sent_at="{ item }">
                                        <v-btn class="text-button" text small
                                               @click="prepareBatchMailDialog(item.last_batch)">
                                            {{ formatDate(item.last_batch.sent_at) }}
                                        </v-btn>
                                    </template>
                                    <template v-slot:item.actions="{ item }">
                                        <v-menu bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon v-on="on">
                                                    <v-icon>mdi-dots-vertical</v-icon>
                                                </v-btn>
                                            </template>

                                            <v-list>
                                                <v-list-item @click="redirectRevival(item)" v-if="item.last_batch.state.code === 'WAITING' &&
                                                item.state.code !== 'DRAFT'">
                                                    <v-list-item-title>
                                                        Modifier
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item @click="redirectCreateRevival(item)"
                                                             v-if="item.last_batch.state.code === 'FINISHED' && item.answer_rate < 1">
                                                    <v-list-item-title>
                                                        Relancer
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item @click="prepareRenameDialog(item)">
                                                    <v-list-item-title>
                                                        Renommer
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item v-if="item.last_batch.state.code !== 'WAITING'"
                                                             @click="redirectCampaignConfig(item)">
                                                    <v-list-item-title>
                                                        Voir la dernière configuration de la campagne
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item @click="duplicate(item)"
                                                             :disabled="!isAccountConfigured || !isCmajAvailable"
                                                             v-if="item.type !== 'CADH' && item.state.code !== 'DRAFT'">
                                                    <v-list-item-title>
                                                        Dupliquer la campagne
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item @click="redirectUpdateCampaign(item)"
                                                             v-if="item.state.code === 'DRAFT'">
                                                    <v-list-item-title>
                                                        Modifier
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item @click="archive(item)" :disabled="isSending(item)"
                                                             v-if="!archived && item.state.code !== 'DRAFT'">
                                                    <v-list-item-title>
                                                        Archiver
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item @click="deleteRevival(item)" v-if="item.last_batch.state.code === 'WAITING' &&
                                                item.state.code !== 'DRAFT'">
                                                    <v-list-item-title style="color: red">
                                                        Annuler
                                                    </v-list-item-title>
                                                </v-list-item>

                                                <v-list-item @click="deleteCampaign(item)"
                                                v-if="deletableStates.includes(item.state.code)">
                                                    <v-list-item-title style="color: red">
                                                        Supprimer
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </template>
                                </v-data-table>
                            </div>
                            <div v-else class="p-3 text-center">
                                <small v-if="isArchived">Aucune campagne archivée</small>
                                <small v-else>Aucune campagne en cours</small>
                            </div>
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog v-model="renameModale" width="600px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">Renommer la campagne</span>
                </v-card-title>

                <v-card-text>
                    <v-text-field outlined label="Nom" v-model="currentCampaign.name"></v-text-field>

                    <v-alert type="error" v-if="currentCampaign.name === ''">
                        Veuillez renseigner un nom.
                    </v-alert>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="renameModale = false">Fermer</v-btn>
                    <v-btn class="default-button" @click="renameCampaign">Enregistrer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="batchEmailModal" width="800px" persistent>
            <v-card>
                <v-card-title class="d-flex justify-content-between">
                    <span class="headline">Contenu de l'e-mail paramétré lors de cet envoi</span>
                    <v-btn text @click="batchEmailModal = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <email-read-only :webForm="currentForm"></email-read-only>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="updateSentAtModal" width="800px" persistent>
            <v-card>
                <v-card-title class="d-flex justify-content-between">
                    <span class="headline">
                        Modification de la date d'envoi de {{updatableSentAtCampaigns.length}}
                        <span v-if="updatableSentAtCampaigns.length > 1"> campagnes</span>
                        <span v-else> campagne</span>
                    </span>
                    <v-btn text @click="updateSentAtModal = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-alert type="info" text class="mb-5" v-if="skipedCampaign">
                        Des campagnes ont été retirées de votre sélection car leurs dates d'envoi ne peuvent pas être modifiées.
                        Seules les campagnes en <b>Brouillon</b> et <b>En attente d'envoi</b> sont modifiables.
                    </v-alert>
                    <div class="mt-3 row" v-if="updatableSentAtCampaigns.length > 0">
                        <div class="col-6">
                            <v-dialog v-model="openStart" persistent max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field label="Date de l'envoi" :value="sentAt" outlined v-on="on"
                                                  @input="updateSentAt"></v-text-field>
                                </template>
                                <v-date-picker locale="fr-FR" color="primary" @change="saveSent"
                                               :first-day-of-week="1">
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="openStart = false">Annuler</v-btn>
                                    <v-btn text color="primary" @click="openStart = false">Valider</v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </div>

                        <div class="col-6">
                            <v-menu v-model="menuHour" :close-on-content-click="false" :return-value.sync="time" ref="menu"
                                    max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field :value="time" label="Heure d'envoi" prepend-icon="access_time"
                                                  @input="updateTime" outlined v-on="on">
                                    </v-text-field>
                                </template>
                                <v-time-picker color="primary" v-if="menuHour" v-model="time" full-width
                                               @click:minute="$refs.menu.save(time)" format="24hr">
                                </v-time-picker>
                            </v-menu>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="updateSentAtModal = false">Fermer</v-btn>
                    <v-btn class="default-button" @click="updateSelectedCampaignsSentAt"
                           :disabled="updatableSentAtCampaigns.length === 0 || sentAt === null || time === null">
                        Modifier
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="aspectChoiceModale" width="600px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">Choix de l'aspect concerné</span>
                </v-card-title>

                <v-card-text>
                    <v-select :items="aspectTypes" outlined class="no-details mb-5" item-text="label" item-value="code"
                              v-model="selectedAspect" return-object label="Aspect">
                    </v-select>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="aspectChoiceModale = false">Fermer</v-btn>
                    <v-btn class="default-button" @click="prepareAspectCampaign"
                           :disabled="selectedAspect === null || selectedAspect === ''">
                        Programmer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
        <confirm ref="confirmArchive" background-title="#1976d2"></confirm>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import Confirm from "../tools/Confirm"
import _ from "lodash-es"
import Loading from "../tools/Loading"
import EmailReadOnly from "./cmaj/stepers/EmailReadOnly.vue"

export default {
    name: "Campaigns",
    components: { Loading, Confirm, EmailReadOnly },
    data() {
        return {
            campaigns: [],
            config: {},
            search: "",
            renameModale: false,
            count: 1,
            loading: false,
            options: { itemsPerPage: 12, page: 1 },
            currentCampaign: {},
            hasCampaigns: true,
            batchEmailModal: false,
            currentForm: {},
            selectedCampaigns: [],
            campaignTypes: [
                {
                    name: "CMAJ",
                    label: "Mise à jour",
                },
                {
                    name: "CADH",
                    label: "Partenariat / adhésion",
                },
            ],
            campaignType: [],
            headers: [
                {
                    text: "Nom",
                    value: "name",
                },
                {
                    text: "Statut",
                    value: "state.label",
                },
                {
                    text: "Prestataires",
                    value: "contacted_providers",
                },
                {
                    text: "Réponses à traiter",
                    value: "responses_to_send",
                },
                {
                    text: "Taux de réponses",
                    value: "answer_rate",
                },
                {
                    text: "Taux d'ouverture",
                    value: "opened_form_rate",
                },
                {
                    text: "Taux d'avancement",
                    value: "complete_rate",
                },
                {
                    text: "Premier envoi",
                    value: "batches.0.sent_at",
                },
                {
                    text: "Dernier envoi",
                    value: "last_batch.sent_at",
                },
                {
                    text: "Actions",
                    value: "actions",
                },
            ],
            updateSentAtModal: false,
            openStart: false,
            today: null,
            time: "08:00",
            menuHour: false,
            skipedCampaign: false,
            sentAt: null,
            updatableSentAtCampaigns: [],
            aspectTypes: [
                {
                    label: 'Tourisme d\'affaires',
                    code: 'business'
                },
                {
                    label: 'Hiver',
                    code: 'winter'
                },
                {
                    label: 'Été',
                    code: 'summer'
                },
              ],
            aspectChoiceModale: false,
            selectedAspect: '',
            deletableStates : [
                'CONFIGURABLE',
                'WAIT_FIRST_SENT',
                'GATHERING',
                'DRAFT',
                'FAILED',
            ],
        }
    },
    methods: {
        ...mapMutations("cmajFilter", [
            "pushWebFormState", "resetState",
        ]),
        ...mapMutations("cadhFilter", [
            "pushFormState", "resetState",
        ]),
        ...mapMutations("campaignFilter", [
            "setDisplayMode", "setArchived", "removeCampaignType", "setOwnCampaign"
        ]),
        setMode(mode) {
            if (mode === "CARD") {
                this.options.itemsPerPage = 12
            } else {
                this.options.itemsPerPage = 10
            }

            this.setDisplayMode(mode)
        },
        scrollTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
        },
        getResponseRate(cmaj) {
            return Math.round(cmaj.answer_rate * 100)
        },
        getOpenedFormRate(cmaj) {
            return cmaj.opened_form_rate !== undefined ? Math.round(cmaj.opened_form_rate * 100) + "%" : "Non disponible"
        },
        getCompleteRate(cmaj) {
            return Math.round(cmaj.complete_rate * 100)
        },
        encodeUri(id) {
            return btoa(id)
        },
        prepareRenameDialog(campaign) {
            this.currentCampaign = JSON.parse(JSON.stringify(campaign))
            this.renameModale = true
        },
        prepareBatchMailDialog(batch) {
            this.$http.post("auth/campaigns/batch-email", { batch: batch }).then(res => {
                this.currentForm = res.body.data.form
                this.batchEmailModal = true
            })
        },
        handleScroll() {
            const scrollTop = window.scrollY || document.documentElement.scrollTop
            const windowHeight = window.innerHeight
            const fullHeight = document.documentElement.scrollHeight
            let errorMargin = 20

            // Ne rien faire si la page n'est pas encore remplie
            if (fullHeight <= windowHeight) return

            if (scrollTop + windowHeight + errorMargin > fullHeight &&
              this.campaigns.length < this.count &&
              !this.loading &&
              this.displayMode === "CARD") {
                this.options.page++
                this.getCampaigns(true)
            }
        },
        getCampaigns: _.debounce(function(concat = false) {
            let payload = {
                archived: this.isArchived,
                search: this.search,
                types: this.campaignType,
                page: this.options.page,
                max: this.options.itemsPerPage,
                owner: this.ownCampaign,
            }

            this.loading = true

            this.$http.post("auth/user/campaigns", payload).then(res => {
                if (!concat) {
                    this.campaigns = res.body.data.campaigns
                } else {
                    this.campaigns = this.campaigns.concat(res.body.data.campaigns)
                }

                this.count = res.body.data.count

                this.loading = false
            })
        }, 500),
        getHasCampaigns() {
            this.$http.get("auth/user/has-campaigns").then(res => {
                this.hasCampaigns = res.body.data.hasCampaigns
            })
        },
        sortCampaigns() {
            if (this.displayMode === "CARD") {
                this.campaigns = _.orderBy(this.campaigns, "created_at", "desc")
            } else {
                this.campaigns = _.orderBy(this.campaigns, "created_at", "desc")
            }
        },
        deleteRevival(campaign) {
            let batch = campaign.last_batch
            let word = campaign.batches.length > 1 ? "relance" : "campagne"

            this.$refs.confirm.open("Suppression de la " + word,
              "Êtes-vous sûr de vouloir supprimer la " + word + " ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    let type = campaign.type === "CADH" ? "cadh" : "cmaj"
                    this.$http.delete("auth/campaigns/" + type + "/revival/" + batch.id).then(res => {
                        this.$global.loading = false

                        this.getCampaigns()
                    })
                }
            })
        },
        getFinishedState(cmaj) {
            let text = ""
            let nbBatches = cmaj.batches.length

            if (nbBatches > 1) {
                text += (nbBatches - 1)
                text += nbBatches === 2 ? "ère" : "ème"
                text += " relance terminée"
            } else {
                text += "1er envoi terminé"
            }

            return text
        },
        redirectAnswer: function(campaign) {
            this.resetState()

            this.pushWebFormState("ANSWERED")

            let hash = btoa(campaign.id)
            let type = campaign.type === "CADH" ? "cadh" : "cmaj"

            if (type === "cadh") {
                this.pushFormState("ANSWERED")
            } else {
                this.pushWebFormState("ANSWERED")
            }

            this.$router.push("/campaign/" + type + "/" + hash)
        },
        redirectCampaignProviders(campaign) {
            this.resetState()

            let hash = btoa(campaign.id)
            let type = campaign.type === "CADH" ? "cadh" : "cmaj"

            if (campaign.state.code !== "WAIT_FIRST_SENT" && campaign.state.code !== "DRAFT") {
                this.$router.push("/campaign/" + type + "/" + hash)
            }
        },
        redirectCampaignConfig(campaign) {
            this.resetState()

            let hash = btoa(campaign.id)

            if (campaign.type === "CADH") {
                this.$router.push("/campaign/cadh/config/" + hash)
            } else {
                this.$router.push("/campaign/cmaj/config/" + hash)
            }
        },
        archive(campaign) {
            this.$refs.confirmArchive.open("Archiver la campagne",
              "Êtes-vous sûr de vouloir archiver la campagne " + campaign.name + " ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    let type = campaign.type === "CADH" ? "cadh" : "cmaj"

                    this.$http.get("auth/campaigns/" + type + "/archive/" + campaign.id).then(res => {
                        this.$global.loading = false
                        this.selectedCampaigns = []
                        this.getCampaigns()
                    })
                }
            })
        },
        duplicate(campaign) {
            if(campaign.aspect === null || campaign.aspect === '') {
                this.$router.push("/campaign/cmaj/duplicate/" + btoa(campaign.id))
            } else {
                this.$router.push("/campaign/cmaj/" + campaign.aspect + "/duplicate/" + btoa(campaign.id))
            }
        },
        isSending(cmaj) {
            let state = cmaj.last_batch.state

            return state.code === "SENDING" || state.code === "PREPARING_1" ||
              state.code === "PREPARING_2" || state.code === "SENDING" ||
              state.code === "WAITING" || state.code === "WAITING_SENDING"
        },
        prepareCmajCampaign() {
            if(this.isCmajAvailable) {
                this.$router.push("/campaign/cmaj/create-scratch")
            }
        },
        prepareCadhCampaign() {
            if(this.isCadhAvailable) {
                this.$router.push("/campaign/cadh/create-scratch")
            }
        },
        prepareConfigAccount() {
            this.$router.push("/onboard")
        },
        prepareAspectCampaign() {
            this.$router.push({ path:"/campaign/casp/create-scratch/" + this.selectedAspect.code })
        },
        isCampaignAvailable(code) {
            let available = false
            let contracts = this.account.current_contracts

            if (contracts.length) {
                contracts.forEach(contract => {
                    let module = contract.contract_offer.options.filter(option => option.code === code)

                    if (module.length) {
                        available = true
                    }
                })
            }
            return available
        },
        redirectRevival(campaign) {
            let type = campaign.type === "CADH" ? "cadh" : "cmaj"

            this.$router.push("revival/" + type + "/update/" + this.encodeUri(campaign.id))
        },
        redirectCreateRevival(campaign) {
            let type = campaign.type === "CADH" ? "cadh" : "cmaj"

            this.$router.push("revival/" + type + "/" + this.encodeUri(campaign.id))
        },
        redirectUpdateCampaign(campaign) {
            let type = campaign.type === "CADH" ? "cadh" : "cmaj"

            this.$router.push("update-campaign/" + type + "/" + this.encodeUri(campaign.id))
        },
        updateFirstSentOrRevival(campaign) {
            if(campaign.batches.length > 1) {
                this.redirectRevival(campaign)
            } else {
                this.redirectUpdateCampaign(campaign)
            }
        },
        getCampaignNavColor(campaign) {
            let color = null

            if (campaign.state.code === "DRAFT") {
                color = "blue-grey lighten-2"
            } else if(campaign.aspect) {
                color = 'casp'
            }
            else {
                color = campaign.type === "CMAJ" ? "cmaj" : "cadh"
            }

            return color
        },
        deleteCampaign(campaign) {
            let message = "Êtes-vous sûr de vouloir supprimer votre campagne <b>" + campaign.name + "</b> ?"

            if (campaign.state.code !== "DRAFT") {
                message += "<br>Les formulaires, et les relances liées à votre campagne seront définitivement supprimés."
            }

            this.$refs.confirm.open("Suppression de la campagne",
              message,
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    let type = campaign.type === "CADH" ? "cadh" : "cmaj"

                    this.$http.delete("auth/campaigns/" + type + "/" + campaign.id).then(res => {
                        this.selectedCampaigns = []
                        this.getCampaigns()

                        this.$global.loading = false
                    })
                }
            })
        },
        renameCampaign() {
            this.$global.loading = true

            let payload = {
                id: this.currentCampaign.id,
                name: this.currentCampaign.name,
            }
            let type = this.currentCampaign.type === "CADH" ? "cadh" : "cmaj"

            this.$http.post("auth/campaigns/" + type + "/rename", payload).then(res => {
                this.$global.loading = false

                this.renameModale = false

                this.getCampaigns()
            })
        },
        getColor(type) {
            return type === "CMAJ" ? "cmaj" : "cadh"
        },
        selectCampaign(campaign) {
            if (!this.selectedCampaigns.includes(campaign)) {
                this.selectedCampaigns.push(campaign)
            } else {
                let index = this.selectedCampaigns.indexOf(campaign)
                this.selectedCampaigns.splice(index, 1)
            }
        },
        archiveSelectedCampaigns() {
            this.$refs.confirmArchive.open("Archivage des campagnes",
              "Êtes-vous sûr de vouloir archiver ces campagnes ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    this.$http.post("auth/campaigns/archive", { campaigns: this.selectedCampaigns }).then(res => {
                        this.$global.loading = false

                        this.options.page = 1
                        this.getCampaigns()
                        this.selectedCampaigns = []
                    })
                }
            })
        },
        deleteSelectedCampaigns() {
            let message =
              "Êtes-vous sûr de vouloir supprimer ces campagnes ?" +
              "<br><br><strong>Les campagnes en cours ou déjà envoyées ne seront pas supprimées,</strong> elles doivent être archivées." +
              "<br>Les formulaires et les relances liés à ces campagnes seront définitivement supprimés."

            this.$refs.confirm.open("Suppression des campagnes",
              message,
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    this.$http.post("auth/campaigns/delete", { campaigns: this.deletableSelectedCampaigns }).then(res => {
                        this.$global.loading = false

                        this.options.page = 1
                        this.getCampaigns()
                        this.selectedCampaigns = []
                    })
                }
            })
        },
        openUpdateSentAtModale() {
            let availableBatchStates = ['WAITING', 'WAITING_SENDING']

            this.updatableSentAtCampaigns = this.selectedCampaigns.filter((campaign) => {
                return availableBatchStates.includes(campaign.last_batch.state.code)
            })

            this.skipedCampaign = this.selectedCampaigns.length !== this.updatableSentAtCampaigns.length

            this.updateSentAtModal = true
        },
        updateSelectedCampaignsSentAt() {
            let dateTime = null

            if (this.sentAt !== null) {
                dateTime = this.sentAt
            }

            if (this.time !== null && dateTime !== null) {
                dateTime += " " + this.time
            }

            let payload = {
                campaigns: this.updatableSentAtCampaigns,
                sentAt: dateTime
            }

            this.$http.post("auth/campaigns/update-sent-at", payload).then(res => {
                this.$global.loading = false

                this.options.page = 1
                this.updatableSentAtCampaigns = []
                this.selectedCampaigns = []
                this.getCampaigns()
                this.updateSentAtModal = false
            })
        },
        saveSent(value) {
            this.openStart = false

            this.sentAt = this.$moment(value).format("DD-MM-YYYY")
        },
        updateSentAt(value) {
            if (value === "") {
                this.sentAt = null
            }
        },
        updateTime(value) {
            if (value === "") {
                this.time = null
            }
        },
    },
    computed: {
        ...mapState("account", ["user", "account"]),
        ...mapState("campaignFilter", ["displayMode", "archived", "ownCampaign"]),
        isArchived: {
            get() {
                return this.archived
            },
            set(value) {
                this.setArchived(value)
            },
        },
        isCampaignType: {
            get() {
                return this.campaignType
            },
            set(value) {
                this.setCampaignType(value)
            },
        },
        isAccountConfigured() {
            return this.config.cgu !== null &&
              this.config.logo !== null &&
              this.config.organism !== null &&
              this.config.oneSender
        },
        isCmajAvailable() {
            return this.isCampaignAvailable("CMAJ")
        },
        isCadhAvailable() {
            return this.isCampaignAvailable("CADH")
        },
        filteredCampaigns() {
            this.sortCampaigns()

            return JSON.parse(JSON.stringify(this.campaigns))
        },
        deletableSelectedCampaigns() {
            return this.selectedCampaigns.filter(campaign => {
                return this.deletableStates.includes(campaign.state.code)
            })
        }
    },
    watch: {
        options(oldValue, newValue) {
            if (oldValue.itemsPerPage !== newValue.itemsPerPage || oldValue.page !== newValue.page) {
                this.getCampaigns()
            }
        },
        isArchived() {
            this.options.page = 1

            this.getCampaigns()
        },
        campaignType() {
            this.options.page = 1

            this.getCampaigns()
        },
        ownCampaign(value) {
            localStorage.ownCampaign = value
            this.options.page = 1

            this.getCampaigns()
        },
        search() {
            this.options.page = 1

            this.getCampaigns()
        },
        displayMode() {
            this.options.page = 1

            this.getCampaigns()
        },
    },
    mounted() {
        this.$nextTick(() => {
            window.scrollTo(0, 0)
            this.debouncedScroll = _.debounce(this.handleScroll, 200)
            window.addEventListener("scroll", this.debouncedScroll)
        })

        if (localStorage.ownCampaign && (localStorage.ownCampaign === "false" || localStorage.ownCampaign === false)) {
            this.setOwnCampaign(false)
        } else if (localStorage.ownCampaign && (localStorage.ownCampaign === "true" || localStorage.ownCampaign === true)) {
            this.setOwnCampaign(true)
        }
    },
    created() {
        this.getCampaigns()
        this.getHasCampaigns()

        this.config = this.account.configurations

        this.today = this.$moment().format("YYYY-MM-DD")

        if(this.account.tis_type.code === 'APIDAE' && this.account.configurations.aspectCampaign) {
            this.campaignTypes.push({
                name: "CASP",
                label: "Mise à jour sur un aspect",
            },)
        }
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.debouncedScroll)
    },
}
</script>